// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ui.compartment-search > input {
    border: none;
    border-radius: 0;
}

.ui.compartment-search.ui.button {
    border: none;
    border-radius: 0;
}

.header-menu-item {
    color: white;
}

.header-menu-item:hover {
    background-color: #232425;
    color: #ddd;
}

.active:hover {
    color: white;
}

/*
 * Control "off" outline (Switch track + unchecked Checkbox box)
 *
 * Mantine's default "off" Switch track and "unchecked" Checkbox box use a low-contrast gray
 * that reads as disabled. To make them visible we stroke them with the same color used to
 * fill them when on/checked (--switch-color / --checkbox-color, i.e. the component's color
 * prop / theme primary). The on/checked, disabled and error states are left untouched.
 *
 * Dark mode uses the full-strength color; light mode uses a more subdued, semi-transparent
 * version so it doesn't read as too bright.
 *
 * Configurable:
 *   --switch-off-border-width           Switch track stroke thickness (both modes)
 *   --control-off-border-light-opacity  how much of the on/checked color to keep in light
 *                                       mode, shared by Switch + Checkbox (lower = subtler)
 * The stroke color follows each component's own color variable, so per-instance \`color\`
 * props are respected without further changes.
 */
:root {
    --switch-off-border-width: 1px;
    --control-off-border-light-opacity: 55%;
}

/* --- Switch track --- */

/* Reserve the border on every state so toggling on/off causes no layout shift. */
.mantine-Switch-track {
    border: var(--switch-off-border-width) solid transparent;
}

/* Off + enabled: stroke with the on-fill color (full strength, used as-is in dark mode). */
.mantine-Switch-input:not(:checked):not(:disabled):not([data-disabled]) + .mantine-Switch-track {
    border-color: var(--switch-color);
}

/* Light mode: subdue the stroke to a semi-transparent version of the on-fill color. */
[data-mantine-color-scheme='light'] .mantine-Switch-input:not(:checked):not(:disabled):not([data-disabled]) + .mantine-Switch-track {
    border-color: color-mix(in srgb, var(--switch-color) var(--control-off-border-light-opacity), transparent);
}

/* --- Checkbox box --- */

/* Unchecked + enabled: stroke with the checked-fill color (full strength, used as-is in dark mode). */
.mantine-Checkbox-input:not(:checked):not(:indeterminate):not([data-indeterminate]):not(:disabled):not([data-disabled]):not([data-error]) {
    border-color: var(--checkbox-color);
}

/* Light mode: subdue the stroke to a semi-transparent version of the checked-fill color. */
[data-mantine-color-scheme='light'] .mantine-Checkbox-input:not(:checked):not(:indeterminate):not([data-indeterminate]):not(:disabled):not([data-disabled]):not([data-error]) {
    border-color: color-mix(in srgb, var(--checkbox-color) var(--control-off-border-light-opacity), transparent);
}

:root {
    --neuroglancer-topview-height: 0;
    --neuroglancer-topview-visibility: collapse;
    --neuroglancer-layout-controls-visibility: collapse;
    --neuroglancer-display-dimensions: collapse;
}

.neuroglancer-panel {
    border-color: var(--mantine-color-section-6) !important;
    border-width: 1px !important;
    border-style: solid !important;
    border-collapse: collapse;
}

/* Fixes differences in the font in sizing due to page font*/
.ng-default-container input {
    margin: 3px;
    font-family: monospace;
    font-size: 13px;
    min-width: 14px;
}

.neuroglancer-viewer-top-row {
    background-color: var(--mantine-color-ngtop-6) !important;
    border-color: red !important;
    color: var(--mantine-color-text) !important; /* Forces the right text color for most items for a given background */
    margin: 0 !important; /* Removes the black shadow under the controls top row */
    padding: 0 !important; /* Removes the black shadow under the controls top row */
    height: var(--neuroglancer-topview-height) !important;
    visibility: var(--neuroglancer-topview-visibility) !important;
}

.neuroglancer-side-panel-titlebar.neuroglancer-layer-side-panel-title {
    background-color: rgb(39, 128, 220) !important;
}

.neuroglancer-side-panel-column {
    color: white !important;
}

.neuroglancer-layer-panel {
    visibility: collapse !important;
    height: 0 !important;
}

.neuroglancer-layer-item-value {
    visibility: collapse !important;
    height: 0 !important;
}

.neuroglancer-layer-panel[data-show-hover-values="true"] {
    visibility: collapse !important;
    color: black !important;
}

/* Toggled with the top control row; hidden by default prevents switching out of 3D view */
.neuroglancer-data-panel-layout-controls {
    visibility: var(--neuroglancer-layout-controls-visibility) !important;
}

.neuroglancer-rendered-data-panel {
    border-color: var(--mantine-color-section-6) !important;
    border-width: 0 !important;
    border-collapse: collapse;
}

/* Fixes differences in the font in sizing due to page font*/
input.neuroglancer-position-dimension-scale {
    min-width: 30px;
}

.neuroglancer-display-dimensions-widget {
    visibility: var(--neuroglancer-display-dimensions) !important;
}

/* Fixes differences in the font in sizing due to page font*/
input.neuroglancer-position-dimension-coordinate {
    min-width: 34px;
}

.perspective-panel-show-slice-views {
    visibility: collapse !important;
    display: none !important;
}

/*
Search Viewer
 */

#neuroglancer-container .neuroglancer-panel {
    border-color: var(--mantine-color-section-6) !important;
    border-width: 1px !important;
    border-style: solid !important;
    border-collapse: collapse;
}
`, "",{"version":3,"sources":["webpack://./../assets/style.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,YAAY;AAChB;;AAEA;;;;;;;;;;;;;;;;;EAiBE;AACF;IACI,8BAA8B;IAC9B,uCAAuC;AAC3C;;AAEA,yBAAyB;;AAEzB,iFAAiF;AACjF;IACI,wDAAwD;AAC5D;;AAEA,2FAA2F;AAC3F;IACI,iCAAiC;AACrC;;AAEA,sFAAsF;AACtF;IACI,0GAA0G;AAC9G;;AAEA,yBAAyB;;AAEzB,sGAAsG;AACtG;IACI,mCAAmC;AACvC;;AAEA,2FAA2F;AAC3F;IACI,4GAA4G;AAChH;;AAEA;IACI,gCAAgC;IAChC,2CAA2C;IAC3C,mDAAmD;IACnD,2CAA2C;AAC/C;;AAEA;IACI,uDAAuD;IACvD,4BAA4B;IAC5B,8BAA8B;IAC9B,yBAAyB;AAC7B;;AAEA,4DAA4D;AAC5D;IACI,WAAW;IACX,sBAAsB;IACtB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,yDAAyD;IACzD,4BAA4B;IAC5B,2CAA2C,EAAE,sEAAsE;IACnH,oBAAoB,EAAE,wDAAwD;IAC9E,qBAAqB,EAAE,wDAAwD;IAC/E,qDAAqD;IACrD,6DAA6D;AACjE;;AAEA;IACI,8CAA8C;AAClD;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,+BAA+B;IAC/B,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;IAC/B,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;IAC/B,uBAAuB;AAC3B;;AAEA,0FAA0F;AAC1F;IACI,qEAAqE;AACzE;;AAEA;IACI,uDAAuD;IACvD,0BAA0B;IAC1B,yBAAyB;AAC7B;;AAEA,4DAA4D;AAC5D;IACI,eAAe;AACnB;;AAEA;IACI,6DAA6D;AACjE;;AAEA,4DAA4D;AAC5D;IACI,eAAe;AACnB;;AAEA;IACI,+BAA+B;IAC/B,wBAAwB;AAC5B;;AAEA;;EAEE;;AAEF;IACI,uDAAuD;IACvD,4BAA4B;IAC5B,8BAA8B;IAC9B,yBAAyB;AAC7B","sourcesContent":[".ui.compartment-search > input {\n    border: none;\n    border-radius: 0;\n}\n\n.ui.compartment-search.ui.button {\n    border: none;\n    border-radius: 0;\n}\n\n.header-menu-item {\n    color: white;\n}\n\n.header-menu-item:hover {\n    background-color: #232425;\n    color: #ddd;\n}\n\n.active:hover {\n    color: white;\n}\n\n/*\n * Control \"off\" outline (Switch track + unchecked Checkbox box)\n *\n * Mantine's default \"off\" Switch track and \"unchecked\" Checkbox box use a low-contrast gray\n * that reads as disabled. To make them visible we stroke them with the same color used to\n * fill them when on/checked (--switch-color / --checkbox-color, i.e. the component's color\n * prop / theme primary). The on/checked, disabled and error states are left untouched.\n *\n * Dark mode uses the full-strength color; light mode uses a more subdued, semi-transparent\n * version so it doesn't read as too bright.\n *\n * Configurable:\n *   --switch-off-border-width           Switch track stroke thickness (both modes)\n *   --control-off-border-light-opacity  how much of the on/checked color to keep in light\n *                                       mode, shared by Switch + Checkbox (lower = subtler)\n * The stroke color follows each component's own color variable, so per-instance `color`\n * props are respected without further changes.\n */\n:root {\n    --switch-off-border-width: 1px;\n    --control-off-border-light-opacity: 55%;\n}\n\n/* --- Switch track --- */\n\n/* Reserve the border on every state so toggling on/off causes no layout shift. */\n.mantine-Switch-track {\n    border: var(--switch-off-border-width) solid transparent;\n}\n\n/* Off + enabled: stroke with the on-fill color (full strength, used as-is in dark mode). */\n.mantine-Switch-input:not(:checked):not(:disabled):not([data-disabled]) + .mantine-Switch-track {\n    border-color: var(--switch-color);\n}\n\n/* Light mode: subdue the stroke to a semi-transparent version of the on-fill color. */\n[data-mantine-color-scheme='light'] .mantine-Switch-input:not(:checked):not(:disabled):not([data-disabled]) + .mantine-Switch-track {\n    border-color: color-mix(in srgb, var(--switch-color) var(--control-off-border-light-opacity), transparent);\n}\n\n/* --- Checkbox box --- */\n\n/* Unchecked + enabled: stroke with the checked-fill color (full strength, used as-is in dark mode). */\n.mantine-Checkbox-input:not(:checked):not(:indeterminate):not([data-indeterminate]):not(:disabled):not([data-disabled]):not([data-error]) {\n    border-color: var(--checkbox-color);\n}\n\n/* Light mode: subdue the stroke to a semi-transparent version of the checked-fill color. */\n[data-mantine-color-scheme='light'] .mantine-Checkbox-input:not(:checked):not(:indeterminate):not([data-indeterminate]):not(:disabled):not([data-disabled]):not([data-error]) {\n    border-color: color-mix(in srgb, var(--checkbox-color) var(--control-off-border-light-opacity), transparent);\n}\n\n:root {\n    --neuroglancer-topview-height: 0;\n    --neuroglancer-topview-visibility: collapse;\n    --neuroglancer-layout-controls-visibility: collapse;\n    --neuroglancer-display-dimensions: collapse;\n}\n\n.neuroglancer-panel {\n    border-color: var(--mantine-color-section-6) !important;\n    border-width: 1px !important;\n    border-style: solid !important;\n    border-collapse: collapse;\n}\n\n/* Fixes differences in the font in sizing due to page font*/\n.ng-default-container input {\n    margin: 3px;\n    font-family: monospace;\n    font-size: 13px;\n    min-width: 14px;\n}\n\n.neuroglancer-viewer-top-row {\n    background-color: var(--mantine-color-ngtop-6) !important;\n    border-color: red !important;\n    color: var(--mantine-color-text) !important; /* Forces the right text color for most items for a given background */\n    margin: 0 !important; /* Removes the black shadow under the controls top row */\n    padding: 0 !important; /* Removes the black shadow under the controls top row */\n    height: var(--neuroglancer-topview-height) !important;\n    visibility: var(--neuroglancer-topview-visibility) !important;\n}\n\n.neuroglancer-side-panel-titlebar.neuroglancer-layer-side-panel-title {\n    background-color: rgb(39, 128, 220) !important;\n}\n\n.neuroglancer-side-panel-column {\n    color: white !important;\n}\n\n.neuroglancer-layer-panel {\n    visibility: collapse !important;\n    height: 0 !important;\n}\n\n.neuroglancer-layer-item-value {\n    visibility: collapse !important;\n    height: 0 !important;\n}\n\n.neuroglancer-layer-panel[data-show-hover-values=\"true\"] {\n    visibility: collapse !important;\n    color: black !important;\n}\n\n/* Toggled with the top control row; hidden by default prevents switching out of 3D view */\n.neuroglancer-data-panel-layout-controls {\n    visibility: var(--neuroglancer-layout-controls-visibility) !important;\n}\n\n.neuroglancer-rendered-data-panel {\n    border-color: var(--mantine-color-section-6) !important;\n    border-width: 0 !important;\n    border-collapse: collapse;\n}\n\n/* Fixes differences in the font in sizing due to page font*/\ninput.neuroglancer-position-dimension-scale {\n    min-width: 30px;\n}\n\n.neuroglancer-display-dimensions-widget {\n    visibility: var(--neuroglancer-display-dimensions) !important;\n}\n\n/* Fixes differences in the font in sizing due to page font*/\ninput.neuroglancer-position-dimension-coordinate {\n    min-width: 34px;\n}\n\n.perspective-panel-show-slice-views {\n    visibility: collapse !important;\n    display: none !important;\n}\n\n/*\nSearch Viewer\n */\n\n#neuroglancer-container .neuroglancer-panel {\n    border-color: var(--mantine-color-section-6) !important;\n    border-width: 1px !important;\n    border-style: solid !important;\n    border-collapse: collapse;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
